import classes from "../Kiosk_viennaPlzen_redesign.module.css";
import {React, useEffect, useState} from "react";
import { assetsBaseUrl } from "../../../../routes";

const Record = (props) =>{
    const [date, setDate] = useState()
    const [logo] = useState(`${assetsBaseUrl}${props.data.path}` || "")

    console.log(props)

    const formatDate = (x) => {
        const date = new Date(x);

        const day = date.getUTCDate();        // getUTCDate kvůli Z (UTC) na konci
        const month = date.getUTCMonth() + 1; // Měsíce jsou 0-11, proto +1

        const formattedDate = `${day}.${month}.`;
        setDate(formattedDate)
    }
    useEffect(() => {
        formatDate(props.data.dateFrom)
    }, [props.data.dateFrom])
    return <div className={classes.record}>
        <div className={classes.meetdate}>{date}</div>
        <div className={classes.meetdate}>{props.data.dateFrom.substring(11,16)}</div>
        <div className={classes.meetdate}>{props.data.dateTo.substring(11,16)}</div>
        <div className={classes.meetdate}>
            <img src={logo} alt=""/>
        </div>
        <div className={classes.meetdate}>{props.data.description}</div>
        <div className={classes.meetdatefrom}></div>
    </div>
}
export default Record